
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticPropsContext } from 'next/types';
import { Makeswift, Page as MakeswiftPage, PageProps as MakeswiftPageProps } from '@makeswift/runtime/next';
import { SWRConfig } from 'swr';
import { ResourceDocument, ResourceFragment } from '@/generated/contentful';
import { client as contentful } from '@/lib/contentful/client';
import { serializeCacheKey } from '@/lib/contentful/utils';
import { getPageSnapshot } from '@/lib/makeswift/client';
import '@/lib/makeswift/components';
import { pageLocales } from '@/utils/locales/page-locales';
import { ResourceMeta } from '@/components/Contentful/entries/Resources/ResourceMeta';
import { PreviewToast } from '@/components/PreviewToast';
type Props = {
    fallback: {
        [key: string]: unknown;
    };
    preview: boolean;
    pageType: string;
    entryItem: ResourceFragment;
} & MakeswiftPageProps;
export default function ResourceReport({ snapshot, fallback, preview, pageType, entryItem }: Props) {
    return (<SWRConfig value={{ fallback }}>
			<PreviewToast preview={preview} pageType={pageType}/>
			<ResourceMeta entryItem={entryItem}>
				<MakeswiftPage snapshot={snapshot}/>
			</ResourceMeta>
		</SWRConfig>);
}
async function getStaticProps({ params, previewData, preview, locale }: GetStaticPropsContext<{
    slug: string;
}, {
    makeswift: boolean;
}>) {
    if (!pageLocales['resources']?.includes(locale as Locale)) {
        console.warn('Locale not supported for /resources/reports/[slug]/');
        return { notFound: true, revalidate: 3600 };
    }
    const client = contentful({ preview: Boolean(preview) });
    const isMakeSwiftPreview = previewData?.makeswift == true;
    const slug = params?.slug;
    if (slug == null) {
        throw new Error('"slug" URL parameter must be defined.');
    }
    const resource = await client.request(ResourceDocument, {
        where: {
            slug,
            ...(isMakeSwiftPreview ? {} : { status: true }),
            type_in: ['Report', 'Report TY']
        },
        limit: 1,
        locale,
        preview: Boolean(preview)
    });
    if (resource?.resourceCollection?.items &&
        resource?.resourceCollection?.items?.length <= 0 &&
        !isMakeSwiftPreview) {
        console.warn(`No resource report found for slug "${slug}" and locale "${locale}"`);
        return { notFound: true, revalidate: 3600 };
    }
    const pageType = resource.resourceCollection?.items?.[0]?.type ?? 'Report';
    const snapshotPathname = pageType === 'Report TY'
        ? '/resources/reports-ty/__template__'
        : '/resources/reports/__template__';
    const snapshot = await getPageSnapshot({
        pathname: snapshotPathname,
        isMakeswiftPreview: previewData?.makeswift == true,
        previewData,
        locale,
        timeout: {
            ms: 10000,
            message: `Timeout request getPageSnapshot for "${snapshotPathname}" – Locale: "${locale}"`
        }
    });
    if (snapshot == null) {
        console.warn(`Could not get snapshot for ${snapshotPathname}`);
        return { notFound: true, revalidate: 3600 };
    }
    return {
        props: {
            snapshot,
            fallback: {
                [serializeCacheKey('resourceReport', { slug, locale })]: resource
            },
            previewMode: Makeswift.getPreviewMode(previewData),
            preview: Boolean(preview),
            revalidate: 3600,
            pageId: resource?.resourceCollection?.items?.[0]?.sys?.id ?? null,
            pageType,
            entryItem: resource.resourceCollection?.items?.[0]
        }
    };
}
export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking'
    };
}

    async function __Next_Translate__getStaticProps__1961694ab69__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/resources/reports/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1961694ab69__ as getStaticProps }
  